/* global $:false */
;(function () {
  'use strict'

  angular
    .module('admin.users.details.shelfies', [])
    .controller('ShelfiesAdminCtrl', ShelfiesAdminCtrl)

  /** @ngInject */
  function ShelfiesAdminCtrl(
    $scope,
    $state,
    $stateParams,
    $sce,
    $rootScope,
    $timeout,
    PostsAdminService,
    UsersService,
  ) {
    var vm = this
    vm.userId = $stateParams.parentId
    vm.items = []
    vm.totalUsers = 0
    vm.usersPerPage = 25
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }

    vm.isOpen = false
    vm.openCalendar = function (e) {
      e.preventDefault()
      e.stopPropagation()

      vm.isOpen = true
    }

    load(1)

    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25
        vm.oldPage = vm.currentPage - 25
      } else {
        vm.first = false
      }

      UsersService.listShelfies(vm.userId, vm.oldPage, 25).then(function (result) {
        var items = result.results
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }

        for (var i = 0; i < items.length; i++) {
          if (items[i]['ts-p'] !== undefined) {
            items[i]['ts-p'] = new Date(
              parseInt(
                items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
              ),
            )
          }
          if (items[i]['ts-x-pin'] !== undefined && items[i]['ts-x-pin'] !== 0) {
            items[i]['ts-x-pin'] = items[i]['ts-x-pin']
              .toString()
              .substring(0, items[i]['ts-x-pin'].toString().length - 3)
            items[i]['ts-x-pin'] = new Date(parseInt(items[i]['ts-x-pin']))
          }
          if (items[i]['img-h'].indexOf('mp4') !== -1) {
            items[i].isVideo = true
            items[i].gif = $rootScope.urlS3 + '/' + items[i]['img-h'].replace('.mp4', '-share.gif')
            items[i].video = $sce.trustAsResourceUrl($rootScope.urlS3 + '/' + items[i]['img-h'])
          } else {
            items[i].isVideo = false
          }
          if (!items[i].pin) {
            items[i].pin = false
          }
          if (!items[i].fea) {
            items[i].fea = false
          }
        }

        vm.items = items
      })
    }

    vm.delete = function (item) {
      swal(
        {
          title: 'Are you Sure?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            if (item['ts-p'] !== undefined || item['ts-p'] !== null) {
              PostsAdminService.unpublish(item.id).then(function () {
                PostsAdminService.remove(item.id).then(function () {
                  $state.reload()
                })
              })
            } else {
              PostsAdminService.remove(item.id).then(function () {
                $state.reload()
              })
            }
          } else {
            return
          }
        },
      )
    }

    vm.pageChanged = function (newPage) {
      load(newPage)
    }

    vm.pin = function (item) {
      swal(
        {
          title: 'Are you Sure?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            var pin
            if (item.pin === false) {
              pin = true
            } else {
              pin = null
            }
            UsersService.shelfiePin(item.id, { pin: pin }).then(
              function () {
                toastr.success('Updated!')
                $state.reload()
              },
              function (err) {
                $timeout(function () {
                  swal(err.error.message, '', 'error')
                }, 250)
              },
            )
          }
        },
      )
    }

    vm.expiration = function (item) {
      vm.item = item
      vm.data = angular.copy(item['ts-x-pin'])
      $('#myModalShelfie').modal('show')
    }

    vm.openImage = function (item) {
      if (item.isVideo) {
        window.open(item.video, '_blank')
      } else {
        window.open($rootScope.urlS3 + '/' + item['img-h'], '_blank')
      }
    }

    var isDate = function (date) {
      return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
    }

    vm.saveModal = function () {
      var newDate
      if (vm.data !== undefined && vm.data !== '' && vm.data !== null) {
        if (isDate(vm.data)) {
          var date = parseInt(new Date(new Date(vm.data).setSeconds(0)).getTime() * 1000)
          newDate = date
        } else {
          swal('Date field invalid.', '', 'error')
          return
        }
      } else {
        newDate = null
      }
      swal(
        {
          title: 'Are you Sure?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            PostsAdminService.update(vm.item.id, { 'ts-x-pin': newDate }).then(
              function () {
                toastr.success('Updated!')
                vm.item = null
                vm.data = null
                $state.reload()
              },
              function (err) {
                $timeout(function () {
                  swal(err.error.message, '', 'error')
                }, 250)
              },
            )
          }
        },
      )
    }

    vm.pool = function (item) {
      swal(
        {
          title: 'Are you Sure?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            var pool
            if (item.fea === false) {
              pool = true
            } else {
              pool = null
            }
            UsersService.shelfiePool(item.id, { fea: pool }).then(
              function () {
                toastr.success('Updated!')
                $state.reload()
              },
              function (err) {
                $timeout(function () {
                  swal(err.error.message, '', 'error')
                }, 250)
              },
            )
          }
        },
      )
    }
  }
})()
